export const fiscalGroupForm = {
	navigateBackGroupLabel: "Volver a grupos fiscales",
	navigateBackCouvertLabel: "Volver a covers fiscales",
	titleSteps: {
		vat: "Impuesto sobre valor agregado (IVA)",
		service: "Servicio",
		serviceNational: "Servicio Nacional",
		general: "Datos generales",
	},
	steps: {
		general: {
			fields: {
				name: {
					label: "Nombre",
					placeholder: "Nombre del grupo",
				},
				type: {
					label: "Tipo",
				},
			},
			types: {
				invoice: "Factura",
				vat: "IVA Portugal",
				vatFactura: "IVA México",
				vatSpain: "IVA España",
				service: "Servicio",
				serviceNational: "Servicio Nacional",
			},
		},
		tip: {
			fiscalGroup: "Grupo fiscal",
			placeholder: "Seleccionar grupo fiscal",
			cestPlaceholder: "Seleccione el CEST",
		},
		vat: {
			fields: {
				taxRate: {
					label: "Alícuota (%)",
				},
				code: {
					label: "SKU",
					placeholder: "Seleccionar SKU",
				},
				productType: {
					label: "Tipo de producto",
					placeholder: "Seleccionar tipo de producto",
				},
				taxExemption: {
					label: "Exención de impuesto",
					placeholder: "Seleccionar exención de impuesto",
				},
				taxType: {
					label: "Tipo de impuesto",
					placeholder: "Seleccionar tipo de impuesto",
				},
			},
			vatVendusTaxExemptionOptions: {
				M01: "Artículo 16.º, n.º 6 del CIVA o similar",
				M02: "Artículo 6.º del decreto-Ley n.º 198/90, de 19 de Junio",
				M03: "Exigibilidad de caja",
				M04: "Artículo 13.º del CIVA o similar",
				M05: "Artículo 14.º del CIVA o similar",
				M06: "Artículo 15.º del CIVA o similar",
				M07: "Artículo 9.º del CIVA o similar",
				M08: "IVA (autoliquidación)",
				M09: "IVA (no confiere derecho a deducción)",
				M10: "IVA (régimen de exención: artículo 53.º del CIVA)",
				M11: "Régimen particular del tabaco",
				M12: "Régimen del margen de beneficio agencias de viajes",
				M13: "Régimen del margen de beneficio bienes de segunda mano",
				M14: "Régimen del margen de beneficio objetos de arte",
				M15: "Régimen del margen de beneficio objetos de colección y antigüedades",
				M16: "Artículo 14.º del RITI o similar",
				M99: "No sujeto; no tributado o similar",
			},
			vatVendusProductTypeOptions: {
				P: "Producto",
				S: "Servicio",
				O: "Otro (portes, anticipos, etc.)",
				I: "Impuesto (excepto IVA e IS) o Cargo Parafiscal",
				E: "Impuesto especial de consumo (IABA, ISP e IT)",
			},
			vatVendusCodeOptions: {
				INT: "Tasa intermedia",
				ISE: "Exento",
				NOR: "Tasa normal",
				RED: "Tasa reducida",
				RED2: "Tasa super reducida",
				OUT: "Tasa excepcional",
				OUT2: "Tasa excepcional 2",
			},
		},
	},
};
